import * as yup from 'yup';

export const documentAttSchema = yup.object().shape({
  description: yup
    .string()
    .max(4000, 'Polje "Opis" mora imati manje od 4000 karaktera.'),

});
